<div class="flex items-center my-2 mx-4" [ngClass]="{'justify-between': isReported, 'justify-end': !isReported}">
    @if (isReported) {
      <p class="grow text-sm inline">{{
        'common.modals.ai-actions.content.message.reported' |
        translate
        }}</p>
    }
    <div class="flex items-center">
        <vw-icon-button [look]="'clear'" [iconTemplate]="infoIconTemplate" (onClick)="onInfoClick()">
            <ng-template #infoIconTemplate>
                <vw-info-icon class="w-5 h-5"></vw-info-icon>
            </ng-template>
        </vw-icon-button>
        <vw-icon-button [look]="'clear'" [iconTemplate]="flagIconTemplate" (onClick)="onFlagClick()">
            <ng-template #flagIconTemplate>
                <vw-flag-icon class="w-5 h-5"></vw-flag-icon>
            </ng-template>
        </vw-icon-button>
    </div>

</div>
<vw-report-modal [isOpen]="showReportPopup" (onReport)="onReport()"
    (onModalClosed)="showReportPopup = false"></vw-report-modal>
<vw-ai-chatbot-info-modal [isOpen]="showInfoPopup" (onModalClosed)="onInfoModalClose()"></vw-ai-chatbot-info-modal>